import { UseFormSetError } from 'react-hook-form';

export const checkClientInviteEmail = (
  email: string | null,
  length: number,
  toastErrors: string[],
  setError: UseFormSetError<any>
) => {
  let isValid = false;
  const emailErrorMessage = 'Формат Email неверный или превышает 256 символов';

  if (email && email.length <= length) {
    const emailRegex =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

    isValid = emailRegex.test(email);

    if (isValid) {
      const arr = email.split('@');
      isValid = arr.length == 2 && arr[1].includes('.');
    }
  }

  if (!isValid) {
    setError('email', {
      type: 'manual',
      message: emailErrorMessage,
    });
    toastErrors.push(emailErrorMessage);
  }

  return toastErrors;
};
